// extracted by mini-css-extract-plugin
export default {"list":"PatientDetailsMenu_list__tOXN7","listItem":"PatientDetailsMenu_listItem__jDXu1","isTouchScreen":"PatientDetailsMenu_isTouchScreen__iYFnB"};